/**
 * Lao eTax submission status (สถานะการนำส่ง)
 *
 * Single source of truth for the status lifecycle shown in the documents
 * table. The backend writers (enqueueLaoEtaxIssue, onTaskIssueLaoEtax,
 * cronPollLaoEtaxVerification) set @LaoEtaxStatus to one of these keys:
 *
 *   queued -> issuing -> issued -> approved | invalid | cancelled
 *                     \-> failed
 *                     \-> verify-timeout   (polling gave up)
 *
 * Chip meta (label/color) derives from
 * this map, so adding a status is a single edit here.
 */
export const LAO_ETAX_STATUS_META = {
  queued: { label: "เข้าคิว", color: "#9e9e9e" },
  issuing: { label: "กำลังส่ง", color: "#1e88e5" },
  issued: { label: "รอตรวจสอบ", color: "#6ec39b" },
  approved: { label: "อนุมัติ", color: "#43a047" },
  "verify-timeout": { label: "ตรวจสอบไม่สำเร็จ", color: "#fb8c00" },
  failed: { label: "ล้มเหลว", color: "#e53935" },
  invalid: { label: "ไม่ผ่าน", color: "#e53935" },
  cancelled: { label: "ยกเลิก", color: "#9e9e9e" },
};

// All known status keys. (The documents table no longer queries by these —
// its status listener follows the rows on screen by document ID; see
// syncLaoStatusListeners in table.vue.)
export const LAO_ETAX_STATUSES = Object.keys(LAO_ETAX_STATUS_META);

// How long a doc may sit in queued/issuing before the UI presumes its attempt
// was lost and offers a retry. MUST match STALE_INFLIGHT_MS in
// firebase/functions/src/libs/libLaoQueue.js, which is authoritative — this
// only decides whether the affordance is shown.
export const LAO_STALE_INFLIGHT_MS = 15 * 60 * 1000;

export default { LAO_ETAX_STATUS_META, LAO_ETAX_STATUSES };
